import { registerEvents } from "./skyward.ui.events";
import { JQueryInput } from "./types";

const textAreasTypedIn = new WeakSet<HTMLTextAreaElement>();

const events =
{
    init
};

registerEvents("textArea", events);

/**
* Write edits as though a user typed it to preserve the undo stack.
*
* Returns false without touching the textarea when the user hasn't typed in it or it can't take focus.
*/
export function setValuePreservingUndo(control: JQuery<HTMLElement>, value: string | number | string[] | null | undefined): boolean
{
    const isEditableTextArea = control.length > 0 && control.is("textarea") && !control.is(":disabled,[readonly]");

    if (!isEditableTextArea)
    {
        return false;
    }

    const textArea = control[0] as HTMLTextAreaElement;
    const text = String(value ?? "");
    const previouslyFocused = document.activeElement as HTMLElement | null;

    // Only the user's own edits are on the undo stack, so there is nothing to keep in step otherwise.
    if (!textAreasTypedIn.has(textArea))
    {
        return false;
    }

    textArea.focus({ preventScroll: true });

    // A hidden textarea can't take focus, and insertText would type into whatever element has it instead.
    if (document.activeElement !== textArea)
    {
        return false;
    }

    textArea.setSelectionRange(0, textArea.value.length);
    const insertSucceeded = document.execCommand("insertText", false, text);

    if (previouslyFocused !== null && previouslyFocused !== textArea)
    {
        // Date and time pickers open on focus unless this is set.
        previouslyFocused.setAttribute("data-suppress-focus", "true");
        previouslyFocused.focus({ preventScroll: true });
        previouslyFocused.removeAttribute("data-suppress-focus");
    }

    // maxlength may truncate the insert, which still counts as written.
    return insertSucceeded;
}

function init(selector: JQueryInput)
{
    $(selector).on("input", function ()
    {
        textAreasTypedIn.add(this as HTMLTextAreaElement);
    });
}
